
import React, { useEffect, useState } from "react";

const CSS = `
* {
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    margin: 0;
    background: #f7f8fa;
    color: #253047;
    font-family: -apple-system, BlinkMacSystemFont,
        "Segoe UI", sans-serif;
    -webkit-font-smoothing: antialiased;
}

button {
    font: inherit;
}

.astrio {
    min-height: 100vh;
}

.container {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 28px;
}

.site-header {
    background: #ffffff;
    border-bottom: 1px solid #e9edf2;
}

.header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 24px;
    padding-bottom: 24px;
}

.brand {
    font-size: 25px;
    font-weight: 800;
    letter-spacing: 3px;
    color: #23334c;
}

.brand-subtitle {
    font-size: 11px;
    color: #8a95a5;
    margin-top: 4px;
}

.header-label {
    color: #8390a1;
    font-size: 12px;
}

.report-intro {
    padding: 52px 0 34px;
}

.eyebrow {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: 700;
    color: #8b739e;
}

.report-intro h1 {
    font-size: 38px;
    letter-spacing: -1px;
    font-weight: 650;
    margin: 12px 0;
}

.report-intro p {
    color: #798497;
    font-size: 15px;
    line-height: 1.7;
    margin: 0;
}

.report-section {
    margin-bottom: 38px;
}

.section-heading {
    margin-bottom: 18px;
}

.section-heading h2 {
    font-size: 22px;
    font-weight: 650;
    letter-spacing: -.4px;
    margin: 0 0 7px;
}

.section-heading p {
    color: #8a94a4;
    font-size: 13px;
    line-height: 1.6;
    margin: 0;
}

.panel {
    background: #ffffff;
    border: 1px solid #e8ecf1;
    border-radius: 14px;
    overflow: hidden;
}

.panel-padding {
    padding: 26px;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 28px;
}

.info-label {
    font-size: 12px;
    color: #929cab;
    margin-bottom: 8px;
}

.info-value {
    font-size: 15px;
    font-weight: 600;
    color: #29374d;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
}

.data-table th {
    background: #fbfcfd;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .8px;
    color: #8c98a9;
    font-weight: 700;
    padding: 17px 22px;
    border-bottom: 1px solid #edf0f4;
}

.data-table td {
    padding: 17px 22px;
    font-size: 14px;
    border-bottom: 1px solid #eff1f5;
    vertical-align: top;
    line-height: 1.6;
    overflow-wrap: anywhere;
}

.data-table tr:last-child td {
    border-bottom: none;
}

.table-primary {
    font-weight: 650;
    color: #30405a;
}

.table-secondary {
    color: #69788d;
}

.table-wrap {
    overflow-x: auto;
}

.panchanga-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.panchanga-item {
    padding: 25px;
    border-right: 1px solid #edf0f4;
    border-bottom: 1px solid #edf0f4;
}

.panchanga-item:nth-child(3n) {
    border-right: none;
}

.panchanga-name {
    color: #8a95a5;
    font-size: 12px;
    margin-bottom: 10px;
}

.panchanga-value {
    color: #2b3950;
    font-size: 17px;
    font-weight: 650;
    overflow-wrap: anywhere;
}

.panchanga-extra {
    color: #8590a0;
    font-size: 12px;
    margin-top: 7px;
}

.detail-panel {
    border: 1px solid #e8ecf1;
    background: white;
    border-radius: 12px;
    margin-bottom: 12px;
    overflow: hidden;
}

.detail-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    width: 100%;
    border: none;
    background: #ffffff;
    text-align: left;
    cursor: pointer;
    padding: 20px 24px;
}

.detail-header:hover {
    background: #fafbfc;
}

.detail-title {
    font-size: 15px;
    font-weight: 650;
    color: #29384e;
    overflow-wrap: anywhere;
}

.detail-subtitle {
    color: #919aaa;
    font-size: 12px;
    margin-top: 5px;
}

.chevron {
    color: #9aa4b2;
    font-size: 19px;
    flex-shrink: 0;
}

.detail-body {
    padding: 6px 24px 24px;
    border-top: 1px solid #f0f2f5;
}

.field-row {
    display: grid;
    grid-template-columns: minmax(170px, 34%) minmax(0, 1fr);
    gap: 18px;
    padding: 13px 0;
    border-bottom: 1px solid #f0f2f5;
    align-items: start;
}

.field-row:last-child {
    border-bottom: none;
}

.field-label {
    color: #7f8b9d;
    font-size: 13px;
    line-height: 1.6;
    overflow-wrap: anywhere;
}

.field-value {
    color: #304059;
    font-size: 13px;
    line-height: 1.8;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.nested-group {
    padding: 14px 0;
    border-bottom: 1px solid #edf0f4;
}

.nested-group:last-child {
    border-bottom: none;
}

.nested-title {
    font-size: 13px;
    font-weight: 650;
    color: #4d5b70;
    margin-bottom: 12px;
}

.nested-content {
    padding-left: 15px;
    border-left: 2px solid #edf0f4;
}

.array-entry {
    padding: 12px 0;
    border-bottom: 1px solid #f0f2f5;
}

.array-entry:last-child {
    border-bottom: none;
}

.array-entry-title {
    font-size: 13px;
    font-weight: 650;
    color: #45536a;
    margin-bottom: 8px;
}

.note {
    background: #faf8f4;
    border: 1px solid #eee7da;
    border-radius: 10px;
    color: #837967;
    font-size: 12px;
    line-height: 1.8;
    padding: 17px 20px;
    margin-top: 18px;
}

.report-footer {
    border-top: 1px solid #e5e9ef;
    padding: 30px 0 50px;
    color: #939eac;
    font-size: 12px;
    line-height: 1.8;
    margin-top: 55px;
}

.loading {
    padding: 100px 20px;
    text-align: center;
    color: #78869a;
}

/* DASHA TIMELINE */

.dasha-period {
    background: #ffffff;
    border: 1px solid #e7ebf1;
    border-radius: 11px;
    margin-bottom: 12px;
    overflow: hidden;
}

.dasha-level-0 {
    border-left: 4px solid #526b91;
}

.dasha-level-1 {
    border-left: 3px solid #a2aec1;
}

.dasha-level-2 {
    border-left: 2px solid #d0d7e2;
}

.dasha-period-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    width: 100%;
    padding: 19px 22px;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;
}

.dasha-period-main:hover {
    background: #fafbfc;
}

.dasha-period-heading {
    min-width: 0;
}

.dasha-period-level {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #9aa4b3;
    font-weight: 650;
    margin-bottom: 6px;
}

.dasha-period-lord {
    font-size: 17px;
    color: #2c3b53;
    font-weight: 650;
    margin-bottom: 6px;
}

.dasha-period-dates {
    color: #8793a3;
    font-size: 12px;
    line-height: 1.7;
}

.dasha-period-meta {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;
}

.dasha-duration {
    color: #6f7d91;
    font-size: 12px;
}

.dasha-toggle {
    color: #8592a4;
    font-size: 20px;
    width: 18px;
    text-align: center;
}

.dasha-period-content {
    padding: 0 22px 20px;
}

.dasha-details-button {
    background: transparent;
    border: none;
    color: #5c7499;
    padding: 12px 0;
    font-size: 12px;
    cursor: pointer;
    text-align: left;
}

.dasha-details-button:hover {
    text-decoration: underline;
}

.dasha-details {
    padding: 12px 16px;
    background: #fafbfd;
    border: 1px solid #edf0f4;
    border-radius: 9px;
    margin-bottom: 16px;
}

.dasha-children {
    padding-left: 20px;
    margin-top: 12px;
    border-left: 1px solid #e8edf3;
}

@media (max-width: 700px) {

    .container {
        padding: 0 16px;
    }

    .header-inner {
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .report-intro {
        padding: 35px 0 28px;
    }

    .report-intro h1 {
        font-size: 29px;
    }

    .header-label {
        display: none;
    }

    .info-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 22px;
    }

    .panel-padding {
        padding: 20px;
    }

    .panchanga-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .panchanga-item:nth-child(3n) {
        border-right: 1px solid #edf0f4;
    }

    .panchanga-item:nth-child(2n) {
        border-right: none;
    }

    .data-table th,
    .data-table td {
        padding: 14px;
    }

    .detail-header {
        padding: 17px;
    }

    .detail-body {
        padding: 8px 17px 18px;
    }

    .field-row {
        grid-template-columns: 1fr;
        gap: 4px;
    }

    .nested-content {
        padding-left: 10px;
    }

    .dasha-period-main {
        padding: 16px;
        gap: 10px;
    }

    .dasha-period-content {
        padding: 0 12px 15px;
    }

    .dasha-children {
        padding-left: 9px;
    }

    .dasha-period-meta {
        gap: 8px;
    }

    .dasha-duration {
        display: none;
    }

    .dasha-period-lord {
        font-size: 15px;
    }
}

/* REPORT TABS */
.report-tabs {
    position: sticky;
    top: 0;
    z-index: 20;
    display: flex;
    gap: 6px;
    overflow-x: auto;
    padding: 12px 0;
    margin-bottom: 30px;
    background: #f7f8fa;
    border-bottom: 1px solid #e3e8ef;
    scrollbar-width: thin;
}
.report-tab {
    flex: 0 0 auto;
    border: 1px solid transparent;
    border-radius: 9px;
    background: transparent;
    color: #66758b;
    padding: 11px 16px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
}
.report-tab:hover { background: #edf1f6; }
.report-tab.active {
    background: #fff;
    color: #293e61;
    border-color: #d7e0eb;
    box-shadow: 0 1px 4px rgba(24, 44, 76, .05);
}
.report-tab:focus-visible { outline: 2px solid #526b91; outline-offset: 2px; }
@media (max-width: 700px) {
    .report-tabs { margin-bottom: 22px; }
    .report-tab { padding: 10px 12px; font-size: 12px; }
}
`;

// --------------------------------------------------
// DATA HELPERS
// --------------------------------------------------

const isObject = (value) =>
    value !== null &&
    typeof value === "object" &&
    !Array.isArray(value);

const isComplex = (value) =>
    value !== null &&
    typeof value === "object";

const prettyLabel = (key) =>
    String(key)
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/_/g, " ")
        .replace(/\s+/g, " ")
        .trim();

const formatValue = (value) => {

    if (value === null) return "Not specified";
    if (value === undefined) return "Not available";
    if (value === "") return "Empty";

    if (typeof value === "boolean") {
        return value ? "Yes" : "No";
    }

    return String(value);
};

const titleFromObject = (item) => {

    if (!isObject(item)) return "";

    const preferredKeys = [
        "Planet",
        "PlanetName",
        "House",
        "Name",
        "Title",
        "DasaLord",
        "DashaLord",
        "Lord",
        "EventName",
        "StartDate",
        "StartTime",
        "Type"
    ];

    for (const key of preferredKeys) {

        if (
            Object.prototype.hasOwnProperty.call(item, key) &&
            !isComplex(item[key])
        ) {
            return formatValue(item[key]);
        }
    }

    const keys = Object.keys(item);

    if (keys.length === 1) {
        return prettyLabel(keys[0]);
    }

    return "";
};

// --------------------------------------------------
// RECURSIVE DATA DISPLAY
// --------------------------------------------------

function DataFields({ value, label = "" }) {

    if (!isComplex(value)) {

        return (
            <div className="field-row">

                <div className="field-label">
                    {prettyLabel(label)}
                </div>

                <div className="field-value">
                    {formatValue(value)}
                </div>

            </div>
        );
    }

    if (Array.isArray(value)) {

        if (value.length === 0) {
            return (
                <div className="field-row">
                    <div className="field-label">
                        {prettyLabel(label)}
                    </div>
                    <div className="field-value">
                        No entries
                    </div>
                </div>
            );
        }

        return (
            <div className="nested-group">

                {label && (
                    <div className="nested-title">
                        {prettyLabel(label)}
                    </div>
                )}

                <div className="nested-content">

                    {value.map((item, index) => {

                        const itemTitle = titleFromObject(item);

                        return (
                            <div
                                className="array-entry"
                                key={index}
                            >

                                {itemTitle && (
                                    <div className="array-entry-title">
                                        {itemTitle}
                                    </div>
                                )}

                                <DataFields
                                    value={item}
                                    label=""
                                />

                            </div>
                        );
                    })}

                </div>

            </div>
        );
    }

    return (
        <div className="nested-group">

            {label && (
                <div className="nested-title">
                    {prettyLabel(label)}
                </div>
            )}

            <div className="nested-content">

                {Object.entries(value).map(([key, child]) => (
                    <DataFields
                        key={key}
                        label={key}
                        value={child}
                    />
                ))}

                {Object.keys(value).length === 0 && (
                    <div className="field-value">
                        No fields
                    </div>
                )}

            </div>

        </div>
    );
}

// --------------------------------------------------
// EXPANDABLE REPORT PANEL
// --------------------------------------------------

function DetailPanel({
    title,
    subtitle,
    children,
    defaultOpen = false
}) {

    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="detail-panel">

            <button
                type="button"
                className="detail-header"
                aria-expanded={open}
                onClick={() => setOpen(!open)}
            >

                <div>

                    <div className="detail-title">
                        {title}
                    </div>

                    {subtitle && (
                        <div className="detail-subtitle">
                            {subtitle}
                        </div>
                    )}

                </div>

                <span className="chevron">
                    {open ? "−" : "+"}
                </span>

            </button>

            {open && (
                <div className="detail-body">
                    {children}
                </div>
            )}

        </div>
    );
}

// --------------------------------------------------
// REPORT SECTION HEADING
// --------------------------------------------------

function SectionHeading({ title, description }) {

    return (
        <div className="section-heading">
            <h2>{title}</h2>
            {description && <p>{description}</p>}
        </div>
    );
}

// --------------------------------------------------
// DASHA HIERARCHY
// --------------------------------------------------

function DashaPeriod({ period, name, level = 0 }) {

    const [open, setOpen] = useState(level === 0);
    const [showDetails, setShowDetails] = useState(false);

    if (!isObject(period)) {
        return (
            <DataFields
                label={name}
                value={period}
            />
        );
    }

    const subDasas = isObject(period.SubDasas)
        ? period.SubDasas
        : {};

    const children = Object.entries(subDasas);

    const levelNames = {
        0: "Mahadasha",
        1: "Bhukti / Antardasha",
        2: "Antaram / Pratyantardasha"
    };

    const levelName =
        levelNames[level] ||
        period.Type ||
        "Dasha Period";

    const lord = period.Lord || name;

    // SubDasas is represented by the child hierarchy.
    // All other source fields are preserved in details.

    const details = Object.fromEntries(
        Object.entries(period).filter(
            ([key]) => key !== "SubDasas"
        )
    );

    return (
        <div
            className={`dasha-period dasha-level-${Math.min(level, 2)}`}
        >

            <button
                type="button"
                className="dasha-period-main"
                onClick={() => setOpen(!open)}
                aria-expanded={open}
            >

                <div className="dasha-period-heading">

                    <div className="dasha-period-level">
                        {levelName}
                    </div>

                    <div className="dasha-period-lord">
                        {lord}
                    </div>

                    <div className="dasha-period-dates">
                        {formatValue(period.Start)}
                        {" — "}
                        {formatValue(period.End)}
                    </div>

                </div>

                <div className="dasha-period-meta">

                    {period.DurationText && (
                        <span className="dasha-duration">
                            {period.DurationText}
                        </span>
                    )}

                    <span className="dasha-toggle">
                        {open ? "−" : "+"}
                    </span>

                </div>

            </button>

            {open && (

                <div className="dasha-period-content">

                    <button
                        type="button"
                        className="dasha-details-button"
                        onClick={() =>
                            setShowDetails(!showDetails)
                        }
                    >
                        {showDetails
                            ? "Hide complete period details"
                            : "View complete period details"}
                    </button>

                    {showDetails && (

                        <div className="dasha-details">

                            <DataFields value={details} />

                        </div>

                    )}

                    {children.length > 0 && (

                        <div className="dasha-children">

                            {children.map(
                                ([childName, childPeriod]) => (

                                    <DashaPeriod
                                        key={childName}
                                        name={childName}
                                        period={childPeriod}
                                        level={level + 1}
                                    />

                                )
                            )}

                        </div>

                    )}

                    {Object.prototype.hasOwnProperty.call(
                        period,
                        "SubDasas"
                    ) && !isObject(period.SubDasas) && (

                        <div className="dasha-details">
                            <DataFields
                                label="Sub Dasas"
                                value={period.SubDasas}
                            />
                        </div>

                    )}

                </div>

            )}

        </div>
    );
}


const ZODIAC_LORDS = {
    Aries: "Mars",
    Taurus: "Venus",
    Gemini: "Mercury",
    Cancer: "Moon",
    Leo: "Sun",
    Virgo: "Mercury",
    Libra: "Venus",
    Scorpio: "Mars",
    Sagittarius: "Jupiter",
    Capricorn: "Saturn",
    Aquarius: "Saturn",
    Pisces: "Jupiter"
};

const ZODIAC_SIGNS = Object.keys(ZODIAC_LORDS);

function calculateHouseLordships(planets, planetDetails, houses) {

    const firstHouse = houses.find(
        house => house.House === "House1"
    );

    const ascendant =
        firstHouse?.AllHouseRasiSigns?.split(":")[0]?.trim();

    const ascendantIndex = ZODIAC_SIGNS.indexOf(ascendant);

    if (ascendantIndex === -1) {
        return [];
    }
    const planetMap = {};

    planetDetails.forEach(entry => {
        Object.entries(entry).forEach(([planet, details]) => {
            planetMap[planet] = details;
        });
    });

    return Array.from({ length: 12 }, (_, index) => {

        const house = index + 1;

        const sign =
            ZODIAC_SIGNS[(ascendantIndex + index) % 12];

        const lord = ZODIAC_LORDS[sign];

        const lordDetails = planetMap[lord] || {};

        const placedIn =
            lordDetails.HousePlanetOccupiesBasedOnSign
                ?.replace("House", "") || "—";

        const placedSign =
            lordDetails.PlanetRasiD1Sign?.Name || "—";

        const otherHouses = Array.from(
            { length: 12 },
            (_, i) => i + 1
        ).filter(h => {
            const hSign =
                ZODIAC_SIGNS[
                    (ascendantIndex + h - 1) % 12
                ];

            return ZODIAC_LORDS[hSign] === lord;
        });

        return {
            house,
            sign,
            lord,
            placedIn,
            placedSign,
            housesRuled: otherHouses.join(", ")
        };
    });
}

// --------------------------------------------------
// MAIN APPLICATION
// --------------------------------------------------

function App() {

    const [activeTab, setActiveTab] = useState("overview");

    const tabs = [
        { id: "overview", label: "Overview" },
        { id: "charts", label: "Charts" },
        { id: "positions", label: "Positions" },
        { id: "strengths", label: "Strength & Aspects" },
        { id: "yogas", label: "Yogas & Doshas" },
        { id: "dasha", label: "Dasha" },
        { id: "transits", label: "Transits" }
    ];

    const switchTab = (tabId) => {
        setActiveTab(tabId);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [gochara, setGochara] = useState(null);
    const [ashtakavarga, setAshtakavarga] = useState(null);
    const [dashaBalance, setDashaBalance] = useState(null);

    const [yogas, setYogas] = useState(null);
const [doshas, setDoshas] = useState(null);

const [aspects, setAspects] = useState(null);
const [strengths, setStrengths] = useState(null);

    useEffect(() => {

        const loadData = async () => {

            try {

                const response = await fetch(
                    `${process.env.PUBLIC_URL}/kundli_output.json`
                );

                if (!response.ok) {
                    throw new Error(
                        "Unable to load kundli_output.json"
                    );
                }

                const result = await response.json();

                setData(result);

            } catch (err) {

                setError(err.message);

            } finally {

                setLoading(false);

            }
        };

        loadData();

    }, []);

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/gochara_positions.json`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Unable to load Gochara data");
                }
                return response.json();
            })
            .then(setGochara)
            .catch(console.error);
    }, []);

    const [bhavaComparison, setBhavaComparison] = useState(null);

    useEffect(() => {

        fetch(`${process.env.PUBLIC_URL}/ashtakavarga.json`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Unable to load Ashtakavarga data");
                }
    
                return response.json();
            })
            .then(setAshtakavarga)
            .catch(console.error);
    
    }, []);

    useEffect(() => {

        const loadCalculations = async () => {
    
            try {
    
                const [yogaResponse, doshaResponse] =
                    await Promise.all([
                        fetch(`${process.env.PUBLIC_URL}/yogas.json`),
                        fetch(`${process.env.PUBLIC_URL}/doshas.json`)
                    ]);
    
                if (!yogaResponse.ok || !doshaResponse.ok) {
                    throw new Error("Unable to load Yoga or Dosha data");
                }
    
                setYogas(await yogaResponse.json());
                setDoshas(await doshaResponse.json());
    
            } catch (error) {
                console.error(error);
            }
    
        };
    
        loadCalculations();
    
    }, []);

    useEffect(() => {

        const loadData = async () => {
    
            try {
    
                const [aspectsResponse, strengthsResponse] =
                    await Promise.all([
                        fetch(`${process.env.PUBLIC_URL}/aspects.json`),
                        fetch(`${process.env.PUBLIC_URL}/strengths.json`)
                    ]);
    
                if (!aspectsResponse.ok || !strengthsResponse.ok) {
                    throw new Error(
                        "Unable to load aspects or strengths data"
                    );
                }
    
                setAspects(await aspectsResponse.json());
                setStrengths(await strengthsResponse.json());
    
            } catch (error) {
                console.error(error);
            }
    
        };
    
        loadData();
    
    }, []);

    useEffect(() => {

        fetch(`${process.env.PUBLIC_URL}/dasha_balance.json`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Unable to load Dasha balance");
                }
    
                return response.json();
            })
            .then(setDashaBalance)
            .catch(console.error);
    
    }, []);

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/bhava_comparison.json`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to load house comparison");
                }
                return response.json();
            })
            .then(setBhavaComparison)
            .catch(console.error);
    }, []);

    if (loading || error || !data) {

        return (
            <>
                <style>{CSS}</style>

                <div className="loading">
                    {loading
                        ? "Preparing astrology report..."
                        : error || "No astrology data available"}
                </div>
            </>
        );
    }

    const birth = data.birthDetails || {};
    const settings = data.calculationSettings || {};
    const panchanga = data.panchanga || {};

    const planets = Array.isArray(data.planets)
        ? data.planets
        : [];

    const houses = Array.isArray(data.houses)
        ? data.houses
        : [];

    const planetDetails = Array.isArray(data.planetDetails)
        ? data.planetDetails
        : [];

        const houseLordships = calculateHouseLordships(
            planets,
            planetDetails,
            houses
        );

    const birthFields = Object.entries(birth);
    const settingFields = Object.entries(settings);

    const primaryPanchanga = [
        {
            key: "tithi",
            title: "Tithi",
            value: isObject(panchanga.tithi)
                ? panchanga.tithi.Name
                : panchanga.tithi
        },
        {
            key: "nakshatra",
            title: "Nakshatra",
            value: panchanga.nakshatra
        },
        {
            key: "karana",
            title: "Karana",
            value: panchanga.karana
        },
        {
            key: "yoga",
            title: "Nitya Yoga",
            value: isObject(panchanga.yoga)
                ? panchanga.yoga.name
                : panchanga.yoga
        },
        {
            key: "vara",
            title: "Vara",
            value: isObject(panchanga.vara)
                ? panchanga.vara.weekday
                : panchanga.vara
        }
    ];

    const knownRootKeys = new Set([
        "birthDetails",
        "calculationSettings",
        "planets",
        "houses",
        "planetDetails",
        "dasha",
        "panchanga"
    ]);

    const extraRootFields = Object.entries(data).filter(
        ([key]) => !knownRootKeys.has(key)
    );

    return (
        <div className="astrio">

            <style>{CSS}</style>

            {/* HEADER */}

            <header className="site-header">

                <div className="container header-inner">

                    <div>

                        <div className="brand">
                            ASTRIO
                        </div>

                        <div className="brand-subtitle">
                            Vedic Astrology
                        </div>

                    </div>

                    <div className="header-label">
                        Birth Chart Calculation Report
                    </div>

                </div>

            </header>

            <main className="container">

                {/* INTRO */}

                <div className="report-intro">

                    <div className="eyebrow">
                        Calculation Review
                    </div>

                    <h1>Birth Chart Report</h1>

                    <p>
                        A complete presentation of the available
                        astrology calculations and source data
                        for professional review.
                    </p>

                </div>

                {/* REPORT NAVIGATION */}
                <nav className="report-tabs" aria-label="Report sections">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            type="button"
                            className={`report-tab ${activeTab === tab.id ? "active" : ""}`}
                            aria-current={activeTab === tab.id ? "page" : undefined}
                            onClick={() => switchTab(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </nav>

                {activeTab === "overview" && (
                    <>

                {/* BIRTH INFORMATION */}

                <section className="report-section">

                    <SectionHeading
                        title="Birth Information"
                        description="Birth parameters used for the calculations."
                    />

                    <div className="panel panel-padding">

                        <div className="info-grid">

                            {birthFields.map(([key, value]) => (

                                <div key={key}>

                                    <div className="info-label">
                                        {prettyLabel(key)}
                                    </div>

                                    <div className="info-value">
                                        {isComplex(value)
                                            ? "See complete details below"
                                            : formatValue(value)}
                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </section>

                {/* CALCULATION SETTINGS */}

                <section className="report-section">

                    <SectionHeading
                        title="Calculation Settings"
                        description="Astrological system and calculation configuration."
                    />

                    <div className="panel panel-padding">

                        <div className="info-grid">

                            {settingFields.map(([key, value]) => (

                                <div key={key}>

                                    <div className="info-label">
                                        {prettyLabel(key)}
                                    </div>

                                    <div className="info-value">
                                        {isComplex(value)
                                            ? "See complete details below"
                                            : formatValue(value)}
                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </section>

                {/* PANCHANGA */}

                <section className="report-section">

                    <SectionHeading
                        title="Birth Panchanga"
                        description="The five traditional Panchanga elements."
                    />

                    <div className="panel">

                        <div className="panchanga-grid">

                            {primaryPanchanga.map((item) => (

                                <div
                                    className="panchanga-item"
                                    key={item.key}
                                >

                                    <div className="panchanga-name">
                                        {item.title}
                                    </div>

                                    <div className="panchanga-value">
                                        {formatValue(item.value)}
                                    </div>

                                    {item.key === "tithi" &&
                                        panchanga.tithi?.Paksha && (

                                            <div className="panchanga-extra">
                                                {panchanga.tithi.Paksha} Paksha
                                            </div>

                                        )}

                                </div>

                            ))}

                        </div>

                    </div>

                    <div style={{ marginTop: 15 }}>

                        <DetailPanel
                            title="Complete Panchanga Calculations"
                            subtitle="All values and calculation metadata"
                        >
                            <DataFields value={panchanga} />
                        </DetailPanel>

                    </div>

                    <div className="note">
                        Nitya Yoga is calculated locally using the
                        sidereal longitudes of the Sun and Moon.
                        Vara currently represents the civil weekday,
                        not a sunrise-based traditional calculation.
                        All results remain subject to professional validation.
                    </div>

                </section>

                {/* ADDITIONAL DATA */}

                {extraRootFields.length > 0 && (

                    <section className="report-section">

                        <SectionHeading
                            title="Additional Calculation Data"
                            description="Other fields available in the generated report."
                        />

                        {extraRootFields.map(([key, value]) => (

                            <DetailPanel
                                key={key}
                                title={prettyLabel(key)}
                            >
                                <DataFields value={value} />
                            </DetailPanel>

                        ))}

                    </section>

                )}

                    </>
                )}

                {activeTab === "charts" && (
                    <>


                {/* BIRTH KUNDLI */}

                <section className="report-section">

                <SectionHeading
                    title="Birth Kundli — North Indian"
                    description="D1 Rasi chart generated using VedAstro with Lahiri ayanamsa."
                />

                <div className="panel panel-padding">

                    <div
                        style={{
                            maxWidth: 650,
                            margin: "0 auto",
                            textAlign: "center"
                        }}
                    >

                        <img
                            src={`${process.env.PUBLIC_URL}/north_indian_d1.svg`}
                            alt="North Indian D1 Birth Kundli"
                            style={{
                                display: "block",
                                width: "100%",
                                height: "auto"
                            }}
                        />

                    </div>

                </div>

                <div className="note">
                    This chart is generated by VedAstro using the same
                    birth details and Lahiri ayanamsa as the planetary
                    calculations. Planetary placements require
                    professional validation.
                </div>

                </section>


                
                {/* DIVISIONAL CHARTS */}

                <section className="report-section">

                <SectionHeading
                    title="Divisional Charts"
                    description="Additional Vedic divisional charts calculated from the birth details using Lahiri ayanamsa."
                />

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))",
                        gap: 20
                    }}
                >

                    {/* NAVAMSHA D9 */}

                    <div className="panel panel-padding">

                        <div
                            style={{
                                fontSize: 17,
                                fontWeight: 650,
                                color: "#29384e",
                                marginBottom: 6
                            }}
                        >
                            Navamsha (D9)
                        </div>

                        <div
                            style={{
                                fontSize: 12,
                                color: "#8793a3",
                                marginBottom: 20
                            }}
                        >
                            Ninth divisional chart
                        </div>

                        <img
                            src={`${process.env.PUBLIC_URL}/navamshad9.svg`}
                            alt="North Indian Navamsha D9 chart"
                            style={{
                                display: "block",
                                width: "100%",
                                height: "auto"
                            }}
                        />

                    </div>

                    {/* DASHAMAMSHA D10 */}

                    <div className="panel panel-padding">

                        <div
                            style={{
                                fontSize: 17,
                                fontWeight: 650,
                                color: "#29384e",
                                marginBottom: 6
                            }}
                        >
                            Dashamamsha (D10)
                        </div>

                        <div
                            style={{
                                fontSize: 12,
                                color: "#8793a3",
                                marginBottom: 20
                            }}
                        >
                            Tenth divisional chart
                        </div>

                        <img
                            src={`${process.env.PUBLIC_URL}/dashamamshad10.svg`}
                            alt="North Indian Dashamamsha D10 chart"
                            style={{
                                display: "block",
                                width: "100%",
                                height: "auto"
                            }}
                        />

                    </div>

                </div>

                <div className="note">
                    These charts are generated from the same birth
                    details as the D1 chart. Their planetary placements
                    have been checked against our independently
                    calculated divisional sign positions.
                    Professional validation remains pending.
                </div>

                </section>

                    </>
                )}

                {activeTab === "positions" && (
                    <>



               {/* PLANETARY POSITIONS */}

                <section className="report-section">

                <SectionHeading
                    title="Planetary Positions"
                    description="Complete planetary placements, Nakshatra, Pada and planetary conditions from VedAstro."
                />

                <div className="panel">

                    <div className="table-wrap">

                        <table className="data-table">

                            <thead>
                                <tr>
                                    <th>Planet</th>
                                    <th>Sign</th>
                                    <th>Degree</th>
                                    <th>House</th>
                                    <th>Nakshatra</th>
                                    <th>Pada</th>
                                    <th>Nakshatra Lord</th>
                                    <th>Retrograde</th>
                                    <th>Combust</th>
                                    <th>Dignity</th>
                                </tr>
                            </thead>

                            <tbody>

                                {planets.map((planet, index) => {

                                    const planetName = planet.Planet;

                                    const detailsEntry = planetDetails.find(
                                        entry =>
                                            entry &&
                                            Object.prototype.hasOwnProperty.call(
                                                entry,
                                                planetName
                                            )
                                    );

                                    const details =
                                        detailsEntry?.[planetName] || {};

                                    const sign =
                                        details.PlanetRasiD1Sign?.Name || "—";

                                    const degree =
                                        details.PlanetRasiD1Sign
                                            ?.DegreesIn
                                            ?.DegreeMinuteSecond || "—";

                                    const house =
                                        details.HousePlanetOccupiesBasedOnSign
                                            ?.replace("House", "House ") || "—";

                                    const constellation =
                                        details.PlanetConstellation || "";

                                    const match = constellation.match(
                                        /^(.*?)\s*-\s*(\d+)$/
                                    );

                                    const nakshatra = match
                                        ? match[1].trim()
                                        : constellation || "—";

                                    const pada = match
                                        ? match[2]
                                        : "—";

                                    const nakshatraLord =
                                        details.PlanetLordOfConstellation
                                            ?.Name || "—";

                                    const formatFlag = value => {
                                        if (value === "True" || value === true) {
                                            return "Yes";
                                        }

                                        if (value === "False" || value === false) {
                                            return "No";
                                        }

                                        return "—";
                                    };

                                    return (
                                        <tr key={planetName || index}>

                                            <td className="table-primary">
                                                {formatValue(planetName)}
                                            </td>

                                            <td>{sign}</td>

                                            <td>{degree}</td>

                                            <td>{house}</td>

                                            <td>{nakshatra}</td>

                                            <td>{pada}</td>

                                            <td>{nakshatraLord}</td>

                                            <td>
                                                {formatFlag(
                                                    details.IsPlanetRetrograde
                                                )}
                                            </td>

                                            <td>
                                                {formatFlag(
                                                    details.IsPlanetCombust
                                                )}
                                            </td>

                                            <td>
                                                {details.PlanetDignity || "—"}
                                            </td>

                                        </tr>
                                    );

                                })}

                            </tbody>

                        </table>

                    </div>

                </div>

                <div className="note">
                    Planetary positions and conditions are sourced
                    from VedAstro. Dignity and planetary condition
                    indicators require professional validation.
                    Detailed source calculations remain available
                    in the Detailed Planetary Analysis section below.
                </div>

                </section>

                {/* HOUSE POSITIONS */}

                <section className="report-section">

                    <SectionHeading
                        title="House Positions"
                        description="House placements returned by the calculation engine."
                    />

                    <div className="panel">

                        <div className="table-wrap">

                            <table className="data-table">

                                <thead>
                                    <tr>
                                        <th>House</th>
                                        <th>Sign &amp; Position</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {houses.map((house, index) => (

                                        <tr key={index}>

                                            <td className="table-primary">
                                                {formatValue(
                                                    house.House
                                                ).replace(
                                                    "House",
                                                    "House "
                                                )}
                                            </td>

                                            <td className="table-secondary">
                                                {formatValue(
                                                    house.AllHouseRasiSigns
                                                )}
                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </table>

                        </div>

                    </div>

                </section>

                {/* HOUSE LORDSHIP ANALYSIS */}

                <section className="report-section">

                <SectionHeading
                    title="House Lords and Their Placements"
                    description="Traditional house rulerships and planetary placements based on the D1 birth chart."
                />

                <div className="panel">
                    <div className="table-wrap">

                        <table className="data-table">

                            <thead>
                                <tr>
                                    <th>House</th>
                                    <th>Sign</th>
                                    <th>Lord</th>
                                    <th>Lord Placed In</th>
                                    <th>Placement Sign</th>
                                    <th>Houses Ruled</th>
                                </tr>
                            </thead>

                            <tbody>

                                {houseLordships.map(item => (

                                    <tr key={item.house}>

                                        <td className="table-primary">
                                            {item.house}
                                        </td>

                                        <td>{item.sign}</td>

                                        <td className="table-primary">
                                            {item.lord}
                                        </td>

                                        <td>
                                            {item.placedIn === "—"
                                                ? "—"
                                                : `House ${item.placedIn}`}
                                        </td>

                                        <td>{item.placedSign}</td>

                                        <td>{item.housesRuled}</td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    </div>
                </div>

                <div className="note">
                    House lordships use traditional Parashari sign
                    rulerships. Rahu and Ketu are not assigned
                    independent house lordships in this calculation.
                    Results require professional validation.
                </div>

                </section>

                {/* LONGITUDE-BASED HOUSE PLACEMENT COMPARISON */}

                {bhavaComparison && (

                <div style={{ marginTop: 32 }}>

                    <h3 style={{
                        fontSize: 20,
                        marginBottom: 8
                    }}>
                        House Placement Comparison
                    </h3>

                    <p style={{
                        color: "#64748b",
                        fontSize: 14,
                        marginBottom: 18,
                        lineHeight: 1.6
                    }}>
                        Comparison of sign-based D1 house placements
                        with VedAstro's longitude-based house placements.
                        A planet may occupy a different house when
                        house boundaries are considered.
                    </p>

                    <div style={{ overflowX: "auto" }}>

                        <table style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            fontSize: 14
                        }}>

                            <thead>
                                <tr>
                                    {[
                                        "Planet",
                                        "Sign-Based D1",
                                        "Longitude-Based",
                                        "Status"
                                    ].map(heading => (
                                        <th
                                            key={heading}
                                            style={{
                                                padding: "12px",
                                                textAlign: "left",
                                                borderBottom: "1px solid #e2e8f0"
                                            }}
                                        >
                                            {heading}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {bhavaComparison.planetaryComparisons.map(
                                    item => (
                                        <tr key={item.planet}
                                            style={{
                                                background: item.changed
                                                    ? "rgba(245, 158, 11, 0.08)"
                                                    : "transparent"
                                            }}
                                        >
                                            <td style={{ padding: 12 }}>
                                                <strong>{item.planet}</strong>
                                            </td>

                                            <td style={{ padding: 12 }}>
                                                {item.signBased.replace("House", "House ")}
                                            </td>

                                            <td style={{ padding: 12 }}>
                                                {item.longitudeBased.replace("House", "House ")}
                                            </td>

                                            <td style={{ padding: 12 }}>
                                                <span style={{
                                                    fontWeight: item.changed ? 600 : 400,
                                                    color: item.changed
                                                        ? "#b45309"
                                                        : "#64748b"
                                                }}>
                                                    {item.changed ? "Changed" : "Unchanged"}
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>

                        </table>

                    </div>

                    <p style={{
                        marginTop: 16,
                        fontSize: 12,
                        color: "#64748b",
                        lineHeight: 1.6
                    }}>
                        Source: VedAstro. House assignments have been
                        checked against the calculated house-longitude
                        boundaries. Exact house-system terminology
                        remains subject to professional confirmation.
                    </p>

                </div>

                )}

                {/* DETAILED PLANETARY DATA */}

                <section className="report-section">

                    <SectionHeading
                        title="Detailed Planetary Analysis"
                        description="Complete planetary calculations, classifications, strengths, relationships and source interpretations."
                    />

                    {planetDetails.map((planetEntry, index) => {

                        if (!isObject(planetEntry)) {

                            return (
                                <DetailPanel
                                    key={index}
                                    title="Planetary Data"
                                >
                                    <DataFields value={planetEntry} />
                                </DetailPanel>
                            );
                        }

                        const entries = Object.entries(planetEntry);

                        if (entries.length === 1) {

                            const [planetName, details] = entries[0];

                            return (
                                <DetailPanel
                                    key={index}
                                    title={prettyLabel(planetName)}
                                    subtitle="Complete planetary information"
                                >
                                    <DataFields value={details} />
                                </DetailPanel>
                            );
                        }

                        return (
                            <DetailPanel
                                key={index}
                                title={
                                    titleFromObject(planetEntry) ||
                                    "Planetary Information"
                                }
                            >
                                <DataFields value={planetEntry} />
                            </DetailPanel>
                        );

                    })}

                    {!Array.isArray(data.planetDetails) &&
                        data.planetDetails !== undefined && (

                            <DetailPanel
                                title="Complete Planetary Details"
                            >
                                <DataFields
                                    value={data.planetDetails}
                                />
                            </DetailPanel>

                        )}

                    <div className="note">
                        Some fields supplied by VedAstro contain
                        interpretive statements rather than purely
                        astronomical calculations. These are retained
                        for review and should not be treated as
                        independently verified conclusions.
                    </div>

                </section>

                    </>
                )}

                {activeTab === "strengths" && (
                    <>


                {/* SHADBALA — PLANETARY STRENGTHS */}

                {strengths && (

                <section className="report-section">

                    <SectionHeading
                        title="Shadbala — Planetary Strengths"
                        description="Planetary strength values sourced from VedAstro, with supporting component and condition details."
                    />

                    <div className="panel" style={{ marginBottom: 20 }}>

                        <div className="panel-padding">
                            <strong>
                                Planetary Strength Summary
                            </strong>
                        </div>

                        <div className="table-wrap">

                            <table className="data-table">

                                <thead>
                                    <tr>
                                        <th>Planet</th>
                                        <th>Shadbala Pinda</th>
                                        <th>Source Strength Flag</th>
                                        <th>Dignity</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {(strengths.classicalPlanets || []).map(
                                        (item) => (

                                            <tr key={item.planet}>

                                                <td className="table-primary">
                                                    {item.planet}
                                                </td>

                                                <td>
                                                    {typeof item.shadbala?.pinda === "number"
                                                        ? item.shadbala.pinda.toFixed(2)
                                                        : "—"}
                                                </td>

                                                <td>
                                                    {item.shadbala?.strong === true
                                                        ? "Strong"
                                                        : item.shadbala?.strong === false
                                                            ? "Not strong"
                                                            : "—"}
                                                </td>

                                                <td>
                                                    {item.conditions?.dignity || "—"}
                                                </td>

                                            </tr>

                                        )
                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                    {(strengths.classicalPlanets || []).map((item) => (

                        <DetailPanel
                            key={item.planet}
                            title={`${item.planet} — Shadbala`}
                            subtitle={`Pinda: ${item.shadbala?.pinda ?? "—"}`}
                        >

                            <DataFields
                                value={{
                                    Shadbala: item.shadbala,
                                    Conditions: item.conditions,
                                    AdditionalStrengths: item.additionalStrengths
                                }}
                            />

                        </DetailPanel>

                    ))}

                    <div className="note">
                        Shadbala values are partially verified.
                        Cheshta Bala is not separately available
                        in the source data. Strength flags, dignity
                        indicators and thresholds require independent
                        validation before professional use.
                    </div>

                </section>

                )}


                {/* GRAHA DRISHTI — PLANETARY ASPECTS */}

                {aspects && (

                <section className="report-section">

                    <SectionHeading
                        title="Graha Drishti — Planetary Aspects"
                        description="Parashari planetary aspects calculated using whole-sign houses from the D1 chart."
                    />

                    <div className="panel" style={{ marginBottom: 20 }}>

                        <div className="panel-padding">
                            <strong>
                                Planetary Aspect Summary
                            </strong>

                            <p className="table-secondary">
                                {aspects.aspects?.length || 0} planetary
                                aspects calculated.
                            </p>
                        </div>

                        <div className="table-wrap">

                            <table className="data-table">

                                <thead>
                                    <tr>
                                        <th>Planet</th>
                                        <th>From</th>
                                        <th>Aspect</th>
                                        <th>To</th>
                                        <th>Planets Aspected</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {(aspects.aspects || []).map(
                                        (item, index) => (

                                            <tr key={index}>

                                                <td className="table-primary">
                                                    {item.fromPlanet}
                                                </td>

                                                <td>
                                                    {item.fromSign}
                                                    {" (H"}
                                                    {item.fromHouse}
                                                    {")"}
                                                </td>

                                                <td>
                                                    {item.aspect}th
                                                </td>

                                                <td>
                                                    {item.toSign}
                                                    {" (H"}
                                                    {item.toHouse}
                                                    {")"}
                                                </td>

                                                <td>
                                                    {item.toPlanets?.length
                                                        ? item.toPlanets.join(", ")
                                                        : "—"}
                                                </td>

                                            </tr>

                                        )
                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                    <div className="panel" style={{ marginBottom: 20 }}>

                        <div className="panel-padding">
                            <strong>House-wise Aspect Summary</strong>
                        </div>

                        <div className="table-wrap">

                            <table className="data-table">

                                <thead>
                                    <tr>
                                        <th>House</th>
                                        <th>Sign</th>
                                        <th>Occupied By</th>
                                        <th>Aspected By</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {(aspects.houses || []).map((item) => (

                                        <tr key={item.house}>

                                            <td className="table-primary">
                                                {item.house}
                                            </td>

                                            <td>{item.sign}</td>

                                            <td>
                                                {item.occupiedBy?.join(", ") || "—"}
                                            </td>

                                            <td>
                                                {item.aspectedBy?.join(", ") || "—"}
                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </table>

                        </div>

                    </div>

                    <div className="note">
                        Rahu and Ketu are included as chart occupants,
                        but do not cast aspects under the selected
                        calculation policy.
                    </div>

                </section>

                )}


                {/* ASHTAKAVARGA */}

                {ashtakavarga && (

                <section className="report-section">

                    <SectionHeading
                        title="Ashtakavarga"
                        description="Bhinnashtakavarga (BAV) and Sarvashtakavarga (SAV) bindu distribution across the twelve zodiac signs."
                    />

                    {/* SARVASHTAKAVARGA */}

                    <div className="panel" style={{ marginBottom: 20 }}>

                        <div className="panel-padding">

                            <div className="detail-title">
                                Sarvashtakavarga (SAV)
                            </div>

                            <p className="table-secondary">
                                Combined bindus contributed by the seven classical planets.
                            </p>

                        </div>

                        <div className="table-wrap">

                            <table className="data-table">

                                <thead>
                                    <tr>
                                        <th>Zodiac Sign</th>
                                        <th>Total Bindus</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {ashtakavarga.sarvashtakavarga?.map(
                                        (item) => (

                                            <tr key={item.sign}>

                                                <td className="table-primary">
                                                    {item.sign}
                                                </td>

                                                <td className="table-secondary">
                                                    {item.bindus}
                                                </td>

                                            </tr>

                                        )
                                    )}

                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td className="table-primary">
                                            Grand Total
                                        </td>
                                        <td className="table-primary">
                                            {ashtakavarga.validation?.savGrandTotal ?? "—"}
                                        </td>
                                    </tr>
                                </tfoot>

                            </table>

                        </div>

                    </div>

                    {/* BHINNASHTAKAVARGA */}

                    <div style={{ marginBottom: 20 }}>

                        <div className="section-heading">
                            <h2>Bhinnashtakavarga (BAV)</h2>
                            <p>
                                Individual planetary bindu distributions.
                            </p>
                        </div>

                        {Object.entries(
                            ashtakavarga.bhinnashtakavarga || {}
                        ).map(([planet, details]) => (

                            <DetailPanel
                                key={planet}
                                title={planet}
                                subtitle={`Total bindus: ${details.total}`}
                            >

                                <div className="table-wrap">

                                    <table className="data-table">

                                        <thead>
                                            <tr>
                                                <th>Zodiac Sign</th>
                                                <th>Bindus</th>
                                            </tr>
                                        </thead>

                                        <tbody>

                                            {details.scores?.map((item) => (

                                                <tr key={item.sign}>

                                                    <td>
                                                        {item.sign}
                                                    </td>

                                                    <td>
                                                        {item.bindus}
                                                    </td>

                                                </tr>

                                            ))}

                                        </tbody>

                                    </table>

                                </div>

                            </DetailPanel>

                        ))}

                    </div>

                    <div className="note">
                        Ashtakavarga values are unadjusted bindu
                        distributions calculated using traditional
                        contribution tables. Internal totals have
                        passed validation; independent verification
                        remains pending.
                    </div>

                </section>

                )}

                    </>
                )}

                {activeTab === "yogas" && (
                    <>

                {/* YOGAS */}

                {yogas && (

                <section className="report-section">

                    <SectionHeading
                        title="Planetary Yogas"
                        description="Selected structural Yoga combinations evaluated from the D1 birth chart."
                    />

                    <div className="panel panel-padding" style={{ marginBottom: 20 }}>

                        <div className="info-grid">

                            <div>
                                <div className="info-label">Evaluated</div>
                                <div className="info-value">
                                    {yogas.summary?.evaluated ?? "—"}
                                </div>
                            </div>

                            <div>
                                <div className="info-label">Detected</div>
                                <div className="info-value">
                                    {yogas.summary?.detected ?? "—"}
                                </div>
                            </div>

                            <div>
                                <div className="info-label">Not Detected</div>
                                <div className="info-value">
                                    {yogas.summary?.notDetected ?? "—"}
                                </div>
                            </div>

                        </div>

                    </div>

                    {(yogas.evaluations || []).map((item, index) => (

                        <DetailPanel
                            key={index}
                            title={`${item.name} — ${(item.planets || []).join(", ")}`}
                            subtitle={item.detected
                                ? "Structural condition detected"
                                : "Structural condition not detected"}
                        >

                            <DataFields
                                value={{
                                    Rule: item.rule,
                                    Reason: item.reason,
                                    Evidence: item.evidence,
                                    StrengthEvaluated: item.strengthEvaluated,
                                    CancellationEvaluated: item.cancellationEvaluated
                                }}
                            />

                        </DetailPanel>

                    ))}

                    <div className="note">
                        Yoga results represent selected structural
                        combinations only. Strength, cancellation,
                        exceptions and overall chart interpretation
                        have not been fully evaluated.
                    </div>

                </section>

                )}


                {/* DOSHAS */}

                {doshas && (

                <section className="report-section">

                    <SectionHeading
                        title="Dosha Analysis"
                        description="Selected structural Dosha evaluations from the D1 birth chart."
                    />

                    <div className="panel panel-padding" style={{ marginBottom: 20 }}>

                        <div className="info-grid">

                            <div>
                                <div className="info-label">
                                    Modules Evaluated
                                </div>
                                <div className="info-value">
                                    {doshas.summary?.modulesEvaluated ?? "—"}
                                </div>
                            </div>

                            <div>
                                <div className="info-label">
                                    Manglik References Detected
                                </div>
                                <div className="info-value">
                                    {doshas.summary?.manglik?.detectedReferences ?? "—"}
                                </div>
                            </div>

                            <div>
                                <div className="info-label">
                                    Kaal Sarpa
                                </div>
                                <div className="info-value">
                                    {doshas.summary?.kaalSarpa?.detected
                                        ? "Detected"
                                        : "Not detected"}
                                </div>
                            </div>

                        </div>

                    </div>

                    {Object.entries(doshas.calculations || {}).map(
                        ([key, calculation]) => (

                            <DetailPanel
                                key={key}
                                title={
                                    key === "manglik"
                                        ? "Manglik / Kuja Dosha"
                                        : key === "kaalSarpa"
                                            ? "Kaal Sarpa Yoga / Dosha"
                                            : key === "kemadruma"
                                                ? "Kemadruma Yoga / Dosha"
                                                : prettyLabel(key)
                                }
                                subtitle="Structural evaluation and supporting evidence"
                            >

                                <DataFields value={calculation} />

                            </DetailPanel>

                        )
                    )}

                    <div className="note">
                        These results evaluate selected structural
                        conditions only. Cancellation rules, exceptions
                        and different astrological traditions may
                        affect interpretation. No definitive prediction
                        or compatibility conclusion is implied.
                    </div>

                </section>

                )}

                    </>
                )}

                {activeTab === "dasha" && (
                    <>


                {/* DASHA BALANCE AT BIRTH */}

                {dashaBalance && (

                <section className="report-section">

                    <SectionHeading
                        title="Vimshottari Dasha Balance at Birth"
                        description="Birth Mahadasha and remaining duration calculated from the Moon's position within its birth Nakshatra."
                    />

                    <div className="panel panel-padding">

                        <div className="info-grid">

                            <div>
                                <div className="info-label">
                                    Birth Nakshatra
                                </div>
                                <div className="info-value">
                                    {dashaBalance.nakshatra}
                                </div>
                            </div>

                            <div>
                                <div className="info-label">
                                    Mahadasha at Birth
                                </div>
                                <div className="info-value">
                                    {dashaBalance.lord}
                                </div>
                            </div>

                            <div>
                                <div className="info-label">
                                    Total Mahadasha Duration
                                </div>
                                <div className="info-value">
                                    {dashaBalance.totalYears} years
                                </div>
                            </div>

                            <div>
                                <div className="info-label">
                                    Elapsed at Birth
                                </div>
                                <div className="info-value">
                                    {dashaBalance.elapsedPercentage.toFixed(2)}%
                                </div>
                            </div>

                            <div>
                                <div className="info-label">
                                    Remaining at Birth
                                </div>
                                <div className="info-value">
                                    {dashaBalance.remainingPercentage.toFixed(2)}%
                                </div>
                            </div>

                            <div>
                                <div className="info-label">
                                    Dasha Balance at Birth
                                </div>
                                <div className="info-value">
                                    {dashaBalance.remainingYears.toFixed(4)} years
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="note">
                        Dasha balance is calculated using the Moon's
                        sidereal position within its birth Nakshatra
                        and the standard Vimshottari Mahadasha durations.
                        Calendar dates depend on the Dasha year-length
                        convention. Professional validation is pending.
                    </div>

                </section>

                )}    

                {/* DASHA */}


                <section className="report-section">

                    <SectionHeading
                        title="Vimshottari Dasha"
                        description="Planetary periods and sub-periods within the requested calculation range."
                    />

                    <div className="dasha-timeline">

                        {isObject(data.dasha) ? (

                            Object.entries(data.dasha).map(
                                ([lord, period]) => (

                                    <DashaPeriod
                                        key={lord}
                                        name={lord}
                                        period={period}
                                        level={0}
                                    />

                                )
                            )

                        ) : (

                            <div className="panel panel-padding">
                                <DataFields
                                    label="Dasha"
                                    value={data.dasha}
                                />
                            </div>

                        )}

                    </div>

                    <div className="note">
                        The displayed dates reflect the requested
                        calculation range and may not represent the
                        actual beginning or ending of a complete
                        Mahadasha. Period descriptions and classifications
                        originate from VedAstro and require professional
                        validation.
                    </div>

                </section>

                    </>
                )}

                {activeTab === "transits" && (
                    <>



                {/* GOCHARA — CURRENT PLANETARY POSITIONS */}

                <section className="report-section">

                <SectionHeading
                    title="Gochara — Current Planetary Positions"
                    description="Planetary positions calculated for the current date using Lahiri ayanamsa."
                />

                <div className="panel panel-padding">

                    <div
                        style={{
                            maxWidth: 650,
                            margin: "0 auto"
                        }}
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/gochara_d1.svg`}
                            alt="Current Planetary Transit Chart"
                            style={{
                                display: "block",
                                width: "100%",
                                height: "auto"
                            }}
                        />
                    </div>

                </div>

                <div className="note">
                    This chart represents planetary positions at the
                    time it was generated. It does not automatically
                    update, and natal-house transit analysis has not
                    yet been calculated.
                </div>

                </section>


                {/* NATAL VS GOCHARA COMPARISON */}

                {gochara && data && (
                    <section className="report-section">

                        <SectionHeading
                            title="Natal vs Gochara Comparison"
                            description={`Transit positions calculated at ${gochara.calculatedAt}`}
                        />

                        <div className="panel panel-padding">

                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>Planet</th>
                                        <th>Natal Position</th>
                                        <th>Transit Position</th>
                                        <th>Transit House</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {gochara.planets.map((planet) => {

                                        const natal = data.planets?.find(
                                            item => item.Planet === planet.Planet
                                        );

                                        const transitSign =
                                            planet.AllPlanetRasiSigns.split(":")[0].trim();

                                        const ascendantSign =
                                            data.houses?.find(
                                                item => item.House === "House1"
                                            )?.AllHouseRasiSigns.split(":")[0].trim();

                                        const signs = [
                                            "Aries", "Taurus", "Gemini", "Cancer",
                                            "Leo", "Virgo", "Libra", "Scorpio",
                                            "Sagittarius", "Capricorn", "Aquarius",
                                            "Pisces"
                                        ];

                                        const ascendantIndex =
                                            signs.indexOf(ascendantSign);

                                        const transitIndex =
                                            signs.indexOf(transitSign);

                                        const houseNumber =
                                            ascendantIndex >= 0 && transitIndex >= 0
                                                ? ((transitIndex - ascendantIndex + 12) % 12) + 1
                                                : null;

                                        return (
                                            <tr key={planet.Planet}>
                                                <td><strong>{planet.Planet}</strong></td>

                                                <td>
                                                    {natal?.AllPlanetRasiSigns || "—"}
                                                </td>

                                                <td>
                                                    {planet.AllPlanetRasiSigns}
                                                </td>

                                                <td>
                                                    {houseNumber
                                                        ? `House ${houseNumber}`
                                                        : "—"}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                        </div>

                        <div className="note">
                            Transit houses are calculated using the whole-sign
                            house convention from the natal Ascendant.
                            The transit data is a saved snapshot, not a live feed.
                        </div>

                    </section>
                )}

                    </>
                )}

                {/* FOOTER */}

                <footer className="report-footer">

                    <div>
                        Astrio · Vedic Astrology Calculation Report
                    </div>

                </footer>

            </main>

        </div>
    );
}

export default App;
